/**
 * Formats a number in cents to a currency string in dollars
 * @param {number} valueInCents - The value in cents to format
 * @returns {string} - The formatted currency string (e.g., "$12.34")
 */
export const currencyFormatter = (valueInCents) => {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(valueInCents / 100);
};
